import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  padding: 0 25px;
`;

export const ButtonBar = styled.ul`
  border-radius: 4px;
  margin: 20px 0;
  padding-left: 0;

  & > li {
    display: inline-block;
  }
`;

export const Button = styled.li`
  background-color: #fff;
  color: ${props => (props.active ? "#194fa1" : "inherit")};
  cursor: ${props => (props.nohover || props.disabled ? "initial" : "pointer")};
  font-weight: bold;
  margin-left: -1px;
  min-width: 39px;
  padding: 6px;
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  text-align: center;
  user-select: none;

  ${props =>
    props.nohover
      ? ""
      : `
    &:hover {
      color: #444854;
      background-color: #eee;
      border-color: #ddd;
    }`};
`;

export const FirstButton = styled(Button)`
  padding: 6px 12px 6px 0;
`;

export const DisplayRowsSelector = styled.span`
  position: relative;

  &::after {
    background: url(/assets/images/icon-chevron-down.svg) center center
      no-repeat;
    background-size: contain;
    content: "";
    height: 10px;
    pointer-events: none;
    position: absolute;
    right: 10px;
    top: 4px;
    width: 10px;
  }
`;

export const Select = styled.select`
  appearance: none;
  border: none;
  cursor: pointer;
  outline: none;
  margin: 0 0 0 25px;
  position: relative;
  width: 50px;
`;
